import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Panel } from 'primereact/panel';
import { Button } from 'primereact/button';
import { Gr8piFormattedDate } from '../../../../components/Gr8piFormattedDateTime';
import { SURVEY_FILE_IMPORT_STATUS } from '../../../../shared/Constants';
import ActivateModal from './ActivateModal';
import { activateSurveyImport } from '../../../../services/apps/SurveyService';
import {
  intlShape, matchShape, growlShape, historyShape,
} from '../../../../components/prop-types';
import { withGrowl } from '../../../../components/GrowlNotifications';
import { growlErrors } from '../../../../utils/NotificationUtil';

const getImportStatus = () => ({
  VALID_IMPORT: (
    <FormattedMessage id="file_import.valid" defaultMessage="Valid">
      {text => <span className="filter filter--info is-active">{text}</span>}
    </FormattedMessage>
  ),
  FAILED_IMPORT: (
    <FormattedMessage id="ile_import.failed" defaultMessage="Failed">
      {text => <span className="filter filter--error is-active">{text}</span>}
    </FormattedMessage>
  ),
  ACTIVATED: (
    <FormattedMessage id="file_import.activated" defaultMessage="Activated">
      {text => <span className="filter filter--success is-active ">{text}</span>}
    </FormattedMessage>
  ),
});
const messages = defineMessages({
  activate: { id: 'actions.activate', defaultMessage: 'Activate' },
});

class DetailInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
    };
    this.openActivateForm = this.openActivateForm.bind(this);
    this.cancelActivate = this.cancelActivate.bind(this);
    this.acceptActivate = this.acceptActivate.bind(this);
  }

  openActivateForm() {
    this.setState({ isModalOpen: true });
  }

  cancelActivate() {
    this.setState({ isModalOpen: false });
  }

  async acceptActivate(formValues) {
    const {
      match: { params }, growl, currentAccount, history,
    } = this.props;
    const { surveyProjectId, importId } = params;
    const { confirmation_code, re_confirmation_code } = formValues;
    if (surveyProjectId && importId && confirmation_code === re_confirmation_code) {
      try {
        await activateSurveyImport({
          accountId: currentAccount,
          surveyProjectId,
          surveyImportId: importId,
        });
        const redirectUrl = `/accounts/${currentAccount}/survey-projects/${surveyProjectId}/`;
        history.push(redirectUrl);
      } catch (errors) {
        growlErrors(growl, errors);
      }
    }
    this.setState({ isModalOpen: false });
  }

  render() {
    const {
      currentAccount,
      imported,
      intl: { formatMessage },
    } = this.props;
    const { isModalOpen } = this.state;
    const isValidSurveyImport = imported.status === SURVEY_FILE_IMPORT_STATUS.VALID;
    const surveyProjectUrl = `/accounts/${currentAccount}/survey-projects/${imported.surveyProject.id}`;
    return (
      <Panel header={imported.fileName}>
        <div className="p-grid">
          <div className="p-col-12">
            <h2 className="text-muted">
              <Link to={surveyProjectUrl}>
                {`${imported.surveyProject.name} - ${imported.surveyProject.surveyTemplate.title}`}
              </Link>
            </h2>
            <div className="details">
              <span className="details-title">
                <FormattedMessage id="attrs.import.status" defaultMessage="Import Status" />
                :
              </span>
              <span>{getImportStatus()[imported.status]}</span>
            </div>
            <div className="details">
              <span className="details-title">
                <FormattedMessage id="attrs.created.verbose" defaultMessage="Created on" />
                :
              </span>
              <span>
                <Gr8piFormattedDate dateValue={imported.createdOn} />
              </span>
            </div>
            <div className="details">
              <span className="details-title">
                <FormattedMessage id="attrs.updated.verbose" defaultMessage="Last update on" />
                :
              </span>
              <span>
                <Gr8piFormattedDate dateValue={imported.updatedOn} />
              </span>
            </div>

            <ActivateModal
              modalOpen={isModalOpen}
              reject={this.cancelActivate}
              confirm={this.acceptActivate}
              def={imported}
            />
          </div>
          <div className="p-col-12">
            {isValidSurveyImport && (
              <Button type="button" label={formatMessage(messages.activate)} onClick={this.openActivateForm} />
            )}
          </div>
        </div>
      </Panel>
    );
  }
}

DetailInfo.propTypes = {
  intl: intlShape.isRequired,
  match: matchShape.isRequired,
  growl: growlShape.isRequired,
  history: historyShape.isRequired,
  imported: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
};

export default withGrowl(
  injectIntl(DetailInfo),
);
